const ITEMS = [
    "Class B & C Multifamily",
    "Sunbelt Markets",
    "Operational Turnarounds",
    "NOI Growth",
    "Asset Stabilization",
    "Value-Add Renovations",
    "Expense Management",
    "Performance",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="overflow-hidden border-y border-white/10 bg-[#060C1B] py-6"
        >
            <div className="animate-marquee flex w-max items-center whitespace-nowrap">
                {row.map((item, i) => (
                    <span
                        key={i}
                        className="mx-8 flex items-center gap-16 text-sm font-semibold uppercase tracking-[0.35em] text-slate-500"
                    >
                        {item}
                        <span className="h-1.5 w-1.5 rotate-45 bg-[#C5A059]" />
                    </span>
                ))}
            </div>
        </div>
    );
}
